export const selectRecentActivityData = (state) =>
  state.capture.recentActivity.data;

export const selectRecentActivityLoading = (state) =>
  state.capture.recentActivity.isLoading;

export const selectRecentActivityError = (state) =>
  state.capture.recentActivity.error;
